import React from 'react';
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import MessageCitations from "../MessageCitations";
import {Dot, ErrorMessageSystemText, LoadingDots, MessageSystem, MessageSystemText} from "./AssistantMessage.styled";
import Thinking from "../Thinking";
import {Citation} from "../../../models/models";

interface AssistantMessageProps {
    hasAttachment: boolean;
    isLoading: boolean;
    isGenerating: boolean;
    isError: boolean;
    errorText: string;
    thinkingText: string;
    responseText: string;
    citations: Citation[];
    openCitationIndex: number | null;
    toggleCitation: (citationIndex: number) => void;
}

const AssistantMessage = ({
    isGenerating,
    isLoading,
    isError,
    hasAttachment,
    errorText,
    thinkingText,
    responseText,
    citations,
    openCitationIndex,
    toggleCitation,
}: AssistantMessageProps) => {
    return (
        <MessageSystem $hasAttachment={hasAttachment}>
            {isLoading
                ? (
                    <LoadingDots>
                        <Dot/>
                        <Dot/>
                        <Dot/>
                    </LoadingDots>
                )
                : (isError ? (
                        <ErrorMessageSystemText>{errorText}</ErrorMessageSystemText>
                    )
                    : (
                        <>
                            <MessageSystemText>
                                <Thinking isGenerating={isGenerating} text={thinkingText} />
                            </MessageSystemText>

                            <MessageSystemText>
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                    {responseText}
                                </ReactMarkdown>
                            </MessageSystemText>

                            <MessageCitations
                                citations={citations}
                                openIndex={openCitationIndex}
                                onToggle={toggleCitation}
                            />
                        </>
                    )
                )
            }
        </MessageSystem>
    );
};

export default AssistantMessage;